import * as angular from 'angular';

import { ComponentDefinition, Category } from '../../../../models';

class CategoriesListController implements angular.IComponentController {
    selectedItem: Category;
    
    readonly categories: Category[];

    static $inject = [];

    select(item: Category) {
        this.selectedItem = item;
    }
}

export const wtCategoriesList: ComponentDefinition = {
    componentId: 'wtCategoriesList',
    controller: CategoriesListController,
    template: require('./categoriesList.component.html'),
    controllerAs: 'vm',
    bindings: {
        categories: '<',
        selectedItem: '=?'
    }
};
